import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import customInputStyle from "../../assets/jss/material-dashboard-react/components/customInputStyle.js";
import Web3 from "web3";
import "react-phone-input-2/lib/style.css";
import dexbot from "../../ABI/dexbot.json";
import config from "../../actions/config";
import {
    getplandata,
    getwithdrawStaking,
    updatewithdrawStaking,

    postPlandata
} from "../../actions/admin.js";
import { toastAlert } from "../../lib/toastAlert.js";
import isEmpty from "../../lib/isEmpty.js";
import { AmpStories } from "@material-ui/icons";
import { idcrtnetwork } from "../../lib/history"

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        // getadminUsers,
        textDecoration: "none",
    },
};

// toaster config
let toasterOption = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const initialFormValue = {
    name: "",
};

const useStyles = makeStyles(styles);

const customStyle = makeStyles(customInputStyle);

export default function UserProfile() {
    const customStyles = customStyle();

    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});
    const [adminnameset, setAdminName] = useState("");
    const [adminid, setadminid] = useState("");
    const [Account, setAccount] = useState()
    const [FormSubmitLoading, Set_FormSubmitLoading] = useState("")
    const [Queenplan, setQueenplan] = useState("")
    const [QueenAmount, setQueenAmount] = useState("")// // console.log(adminid);
    // // console.log(adminnameset, "adminnamesetadminnamesetadminnameset");
    const [FormSubmitLoading1, Set_FormSubmitLoading1] = useState("")


    const onChange = (e) => {
        e.preventDefault();
        if (e.target.name === "kingamount") {
            const { name, value } = e.target;
            setAdminName(value);


        } else if (e.target.name === "QueenAmount") {
            const { name, value } = e.target;
            setQueenAmount(value);


        }
    };



    useEffect(() => {
        acc();
    }, []);

    const acc = async () => {
        const web3 = new Web3(window.ethereum);
        let accounts = await web3.eth.requestAccounts();
        setAccount(accounts);
    };



    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (Account != config.admin_address) {
            toast.error("connect your valid account", toasterOption);
            return false;
        }
        const iscrtnet = await idcrtnetwork()
        // console.log(iscrtnet);
        if (iscrtnet == false) {
            return false
        }
        try {
            Set_FormSubmitLoading("processing")
            const web3 = new Web3(window.ethereum);
            function convert(n) {

                var sign = +n < 0 ? "-" : "",
                    toStr = n.toString();
                if (!/e/i.test(toStr)) {
                    return n;
                }
                var [lead, decimal, pow] = n
                    .toString()
                    .replace(/^-/, "")
                    .replace(/^([0-9]+)(e.*)/, "$1.$2")
                    .split(/e|\./);
                return +pow < 0
                    ? sign +
                    "0." +
                    "0".repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) +
                    lead +
                    decimal
                    : sign +
                    lead +
                    (+pow >= decimal.length
                        ? decimal + "0".repeat(Math.max(+pow - decimal.length || 0, 0))
                        : decimal.slice(0, +pow) + "." + decimal.slice(+pow));
            }
            
            const datacalcul = adminnameset * 10 ** 18
            var amt = datacalcul.toString();
            amt = convert(amt);


            const BEPContract = new web3.eth.Contract(
                dexbot,
                config.contract_address
            );


            await BEPContract.methods.updatePrice(adminid, amt).send({
                from: config.admin_address,
            });

            let reqData = {
                StakingLimit: adminnameset,
                plan: adminid,
            };
            // console.log(reqData, "adminid");
            const { status, message, error, result } = await postPlandata(reqData);


            if (status) {
                toastAlert("success", message, "Admin");
                history.push("/dashboard");
                Set_FormSubmitLoading("done")
                //window.location=('/categorylist')
            } else if (error) {
                setValidateError(error);
                Set_FormSubmitLoading("done")
            }
        } catch (err) {
            // // console.log(err.length);
            toast.error("Transaction rejected by user", toasterOption);
            Set_FormSubmitLoading("done")
        }
    };



    const handleSubmitQueen = async (e) => {
        e.preventDefault();
        if (Account != config.admin_address) {
            toast.error("connect your valid account", toasterOption);
            return false;
        }
        const iscrtnet = await idcrtnetwork()
        // console.log(iscrtnet);
        if (iscrtnet == false) {
            return false
        }

        try {
            Set_FormSubmitLoading1("processing")
            const web3 = new Web3(window.ethereum);
            function convert(n) {

                var sign = +n < 0 ? "-" : "",
                    toStr = n.toString();
                if (!/e/i.test(toStr)) {
                    return n;
                }
                var [lead, decimal, pow] = n
                    .toString()
                    .replace(/^-/, "")
                    .replace(/^([0-9]+)(e.*)/, "$1.$2")
                    .split(/e|\./);
                return +pow < 0
                    ? sign +
                    "0." +
                    "0".repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) +
                    lead +
                    decimal
                    : sign +
                    lead +
                    (+pow >= decimal.length
                        ? decimal + "0".repeat(Math.max(+pow - decimal.length || 0, 0))
                        : decimal.slice(0, +pow) + "." + decimal.slice(+pow));
            }
            const datacalcul = QueenAmount * 10 ** 18
            var amt = datacalcul.toString();
            amt = convert(amt);


            const BEPContract = new web3.eth.Contract(
                dexbot,
                config.contract_address
            );


            await BEPContract.methods.updatePrice(Queenplan, amt).send({
                from: config.admin_address,
            });

            let reqData = {
                StakingLimit: QueenAmount,
                plan: Queenplan,
            };
            // console.log(reqData, "adminid");
            const { status, message, error, result } = await postPlandata(reqData);


            if (status) {
                toastAlert("success", message, "Admin");
                history.push("/dashboard");
                Set_FormSubmitLoading1("done")
                //window.location=('/categorylist')
            } else if (error) {
                setValidateError(error);
                Set_FormSubmitLoading1("done")
            }
        } catch (err) {
            // // console.log(err.length);
            toast.error("Transaction rejected by user", toasterOption);
            Set_FormSubmitLoading1("done")
        }
    };





    const getadmindata = async () => {
        var result = await getplandata();
        console.log(result);

        if (result != null) {
            setadminid(result.result.Data[0]?.plan);
            setAdminName(result.result.Data[0]?.Plan_amount);
            setQueenplan(result.result.Data[1]?.plan);
            setQueenAmount(result.result.Data[1]?.Plan_amount)
        }
    };
    useEffect(() => {
        //logout(history)
        getadmindata();
    }, []);

    return (
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <form
                            className={classes.form}
                            onSubmit={handleFormSubmit}
                            noValidate
                        >
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>
                                    Update King Price
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={3}>
                                        <CustomInput
                                            labelText="King Price"
                                            onChange={onChange}
                                            name="kingamount"
                                            value={adminnameset}
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                        />


                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                            <CardFooter>
                                <Button color="primary" type="submit" disabled={FormSubmitLoading == "processing"}>
                                    {FormSubmitLoading == "processing" && (
                                        <i
                                            class="fa fa-spinner fa-spin"
                                            aria-hidden="true"
                                            id="circle"
                                        ></i>
                                    )}
                                    Update
                                </Button>
                            </CardFooter>
                        </form>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <form
                            className={classes.form}
                            onSubmit={handleSubmitQueen}
                            noValidate
                        >
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>
                                    Update Queen Price
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={3}>
                                        <CustomInput
                                            labelText="Queen Price"
                                            onChange={onChange}
                                            name="QueenAmount"
                                            value={QueenAmount}
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                        />


                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                            <CardFooter>
                                <Button color="primary" type="submit" disabled={FormSubmitLoading1 == "processing"}>
                                    {FormSubmitLoading1 == "processing" && (
                                        <i
                                            class="fa fa-spinner fa-spin"
                                            aria-hidden="true"
                                            id="circle"
                                        ></i>
                                    )}
                                    Update
                                </Button>
                            </CardFooter>
                        </form>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
